import SimcardActionsModal from './SimcardActionsModal';
import LorawanActionsModal from './LorawanActionsModal';
import LorawanActionsModalNew from './LorawanActionsModalNew';

const ActionsModalByTypes = {
  Simcard: SimcardActionsModal,
  Lorawan: LorawanActionsModal,
  LorawanNew: LorawanActionsModalNew,
};

export default ActionsModalByTypes;
